import React from "react";
import ReactDOM from "react-dom";
import ApolloClient from "apollo-boost";
import { ApolloProvider } from "react-apollo";
import { ThemeProvider } from "styled-components";
import WebfontLoader from "@dr-kobros/react-webfont-loader";
import ReactGA from "react-ga";

import App from "./components/App";

import "./reset.css";
import registerServiceWorker from "./registerServiceWorker";
import { theme } from "./theme";
import { SERVER_URL } from "./api/constants";

const client = new ApolloClient({
    uri: `${SERVER_URL}/graphql`
});

const config = {
    typekit: {
        id: "aeb4pxs"
    }
};

ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);

ReactDOM.render(
    <ApolloProvider client={client}>
        <WebfontLoader config={config}>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </WebfontLoader>
    </ApolloProvider>,
    document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js